enum ContactCarePlusSupport {
  Chewy,
  Trupanion,
  Lemonade,
}
export interface ContactDetails {
  contactType: ContactCarePlusSupport;
  label: string;
  phoneNumber: string;
  link: string;
}

export const chewyCarePlusSupport: ContactDetails = {
  contactType: ContactCarePlusSupport.Chewy,
  label: 'Chewy CarePlus Support',
  phoneNumber: '1-800-672-4399',
  link: 'tel:+18006724399',
};

export const trupanionCarePlusSupport: ContactDetails = {
  contactType: ContactCarePlusSupport.Trupanion,
  label: 'Trupanion CarePlus Support',
  phoneNumber: '844-958-1679',
  link: 'tel:8449581679',
};

export const lemonadeCarePlusSupport: ContactDetails = {
  contactType: ContactCarePlusSupport.Lemonade,
  label: 'Lemonade CarePlus Support',
  phoneNumber: '1-844-733-7139',
  link: 'tel:+18447337139',
};
